// 销方管理
const invoiceSellerManageJurisdiction = [
  { id: "016001001", label: "添加", children: [] },
  { id: "016001002", label: "修改", children: [] },
  { id: "016001003", label: "删除", children: [] }
];

// 税率管理
const invoiceTaxRateManageJurisdiction = [
  { id: "016002001", label: "添加", children: [] },
  { id: "016002002", label: "修改", children: [] },
  { id: "016002003", label: "删除", children: [] }
];

// 抬头管理
const invoiceRiseManageJurisdiction = [
  { id: "016003001", label: "添加", children: [] },
  { id: "016003002", label: "修改", children: [] },
  { id: "016003003", label: "删除", children: [] }
];

// 发票管理
const invoiceManageJurisdiction = [
  { id: "016004001", label: "开票", children: [] },
  { id: "016004002", label: "批量同步发票状态", children: [] },
  { id: "016004003", label: "作废", children: [] },
  { id: "016004004", label: "红冲", children: [] }
];

// 收据管理
const invoiceReceiptCollectionRecordJurisdiction = [
  { id: "016005001", label: "开收据", children: [] }
];

const invoiceServiceJurisdictionChildren = [
  {
    id: "016007000",
    label: "概览",
    routerName: "invoice-over-view",
    children: []
  },
  {
    id: "016001000",
    label: "销方管理",
    routerName: "invoice-seller-manage",
    children: invoiceSellerManageJurisdiction
  },
  {
    id: "016002000",
    label: "税率管理",
    routerName: "invoice-tax-rate-manage",
    children: invoiceTaxRateManageJurisdiction
  },
  {
    id: "016003000",
    label: "抬头管理",
    routerName: "invoice-rise-manage",
    children: invoiceRiseManageJurisdiction
  },
  {
    id: "016004000",
    label: "发票管理",
    routerName: "invoice-manage",
    children: invoiceManageJurisdiction
  },
  {
    id: "016005000",
    label: "收据管理",
    routerName: "invoice-receipt-collection-record",
    children: invoiceReceiptCollectionRecordJurisdiction
  },
  {
    id: "016006000",
    label: "操作日志",
    routerName: "invoice-log",
    children: []
  }
];

const invoiceServiceJurisdiction = {
  id: "016",
  label: "智慧凭证",
  children: invoiceServiceJurisdictionChildren
};

export { invoiceServiceJurisdiction };



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/invoiceServiceJurisdiction.js